import { inject, Injectable } from '@angular/core';
import { StorageKeys } from '../config';
import { LOCAL_STORAGE_PROTECTED_KEYS } from '../config/storage-tokens';

@Injectable({
	providedIn: 'root',
})
export class LocalStorageService {
	private readonly builtInProtectedKeys: string[] = [
		StorageKeys.TABLES_COLUMNS,
		StorageKeys.USER_LANGUAGE,
		StorageKeys.THEME_COLOR,
		StorageKeys.FONT_SIZE,
	];

	private readonly extraProtectedKeys: string[] = inject(LOCAL_STORAGE_PROTECTED_KEYS);

	public getItem(key: string): string | null {
		return localStorage.getItem(key);
	}

	public setItem(key: string, value: string): void {
		localStorage.setItem(key, value);
	}

	public removeItem(key: string): void {
		localStorage.removeItem(key);
	}

	public clearAll(): void {
		const allProtectedKeys = [...this.builtInProtectedKeys, ...this.extraProtectedKeys];
		const saved: Record<string, string | null> = {};

		for (const key of allProtectedKeys) {
			saved[key] = this.getItem(key);
		}

		localStorage.clear();

		for (const key of allProtectedKeys) {
			if (saved[key] !== null) {
				localStorage.setItem(key, saved[key]);
			}
		}
	}
}
